import { render, staticRenderFns } from "./popoverImg.vue?vue&type=template&id=78bb7335&scoped=true"
import script from "./popoverImg.vue?vue&type=script&lang=js"
export * from "./popoverImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bb7335",
  null
  
)

export default component.exports